import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { MaintenanceDataCDTComponent } from "./maintenance-data-cdt.component";
import { CreateEditDataCdtComponent } from "./create-edit-data-cdt/create-edit-data-cdt.component";
import { ListDataCdtComponent } from "./list-data-cdt/list-data-cdt.component";
import { LoginGuard } from "../core/guards/login.guard";
import { PwdExpiratedGuard } from "../core/guards/pwdExpirated";

const routesDatosCDT: Routes = [
  {
    path: "",
    component: MaintenanceDataCDTComponent,
    canActivate: [LoginGuard, PwdExpiratedGuard],
    children: [
      {
        path: "lista",
        component: ListDataCdtComponent,
      },
      {
        path: "creacion",
        component: CreateEditDataCdtComponent,
        data: {
          operation: "creacion",
        },
      },
      {
        path: "edicion/:id",
        component: CreateEditDataCdtComponent,
        data: {
          operation: "edicion",
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routesDatosCDT)],
  exports: [RouterModule],
})
export class DataCDTRoutingModule {}
